import { useForm } from 'react-hook-form'
import { IManagementAccountantsSearchForm } from 'lib/forms/management/management.form.models'
import withTextInputController from 'hocs/withTextInputController'
import Button from 'components/Shared/Button/Button'
import FormTextInput from 'components/FormComponents/FormTextInput/FormTextInput'
import './styles.scss'

interface IManagementAccountantsSearchProps {
  onSubmit: (data: IManagementAccountantsSearchForm) => void
}

const ControlledTextInput = withTextInputController(FormTextInput)

const ManagementAccountantsSearch = ({
  onSubmit,
}: IManagementAccountantsSearchProps) => {
  const { control, handleSubmit } = useForm<IManagementAccountantsSearchForm>({
    defaultValues: {
      search: '',
    },
  })

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="management-accountants-search">
      <ControlledTextInput
        className="accountants-search-bar"
        control={control}
        name="search"
        label="Buscar"
        placeholder="Buscar por Nombre, ID,  Equipo asignado o correo"
      />
      <Button variant="outlined" color="secondary" type="submit">
        Buscar
      </Button>
    </form>
  )
}

export default ManagementAccountantsSearch
